import { Component, input } from '@angular/core';

import {
    TableRowData,
    hasCarrierNumberPlateIncoming,
    hasCarrierNumberPlateOutgoing,
} from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

export type LicensePlateType = 'incoming' | 'outgoing';

@Component({
    selector: 'app-license-plates-display',
    standalone: true,
    imports: [],
    template: ` <span>{{ displayValue }}</span> `,
})
export class LicensePlatesDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    item = input<TableRowData>(); // legacy alias
    parentRow = input<TableRowData>(); // for expanded rows
    plateType = input<LicensePlateType>('incoming');

    get rowData(): TableRowData {
        return (this.row() || this.item()) as TableRowData;
    }

    get displayValue(): string {
        if (this.plateType() === 'incoming') {
            return hasCarrierNumberPlateIncoming(this.rowData)
                ? this.rowData.carrierNumberPlateIncoming || ''
                : '';
        } else {
            const rowPlate = hasCarrierNumberPlateOutgoing(this.rowData)
                ? this.rowData.carrierNumberPlateOutgoing
                : undefined;
            const parentRow = this.parentRow();
            const parentPlate = hasCarrierNumberPlateOutgoing(parentRow)
                ? parentRow.carrierNumberPlateOutgoing
                : undefined;

            return rowPlate || parentPlate || '';
        }
    }
}
